import { request } from '@umijs/max';
import { IRoleProps } from './typing';

export async function queryRolesService() {
  return request(`/bcare/bfmRole/list`).then((res) => {
    if (res?.length) {
      return res
        .filter(
          (r: IRoleProps) => r.roleId === r.parentRoleId || !r.parentRoleId,
        )
        .map((item: IRoleProps) => {
          if (item.parentRoleId) {
            const children = res.filter(
              (c: IRoleProps) =>
                c.parentRoleId === item.roleId && c.parentRoleId !== c.roleId,
            );
            return {
              ...item,
              children,
            };
          }
          return item;
        });
    }
    return [];
  });
}

export async function deleteRoleService(roleId: number) {
  return request(`/roles/${roleId}`, {
    method: 'DELETE',
  });
}

export async function addRoleService(data: any) {
  return request(`/roles`, {
    method: 'POST',
    data,
  });
}

export async function addRoleServiceByGroup(data: any) {
  return request(`/bcare/bfmRole/add`, {
    method: 'POST',
    data,
  });
}

export async function editRoleService(data: any) {
  return request(`/roles`, {
    method: 'PUT',
    data,
  });
}

export async function queryPortalsByRoleIdService(roleId: number) {
  return request(`/roles/${roleId}/portals`);
}

export async function addPortalsByRoleIdService(roleId: number, data: any) {
  return request(`/roles/${roleId}/portals/new`, {
    method: 'PUT',
    data,
  });
}

export async function deletePortalsByRoleIdService(roleId: number, data: any) {
  return request(`/roles/${roleId}/portals`, {
    method: 'DELETE',
    data,
  });
}

export async function queryMenusByRoleIdService(roleId: number) {
  return request(`/roles/${roleId}/menus`);
}

export async function addMenusByRoleIdService(roleId: number, data: any) {
  return request(`/roles/${roleId}/privs/new`, {
    method: 'POST',
    data,
  });
}

export async function deleteMenusByRoleIdService(roleId: number, data: any) {
  return request(`/roles/${roleId}/privs/new`, {
    method: 'DELETE',
    data,
  });
}

export async function queryButtonsByRoleIdAndMenuIdService(
  roleId: number,
  menuId: number,
) {
  return request(`/bcare/bfmRole/roleButton/list/${roleId}/${menuId}`);
}

export async function delAuthButtonService(data: any) {
  return request(`/bcare/bfmRole/roleButton/add`, {
    method: 'POST',
    data,
  });
}

export async function addAuthButtonService(data: any) {
  return request(`/bcare/bfmRole/roleButton/del`, {
    method: 'POST',
    data,
  });
}
